import { IBedTypeWithMeta } from '../interfaces-v2/bed-type-meta-data.interface';
import { BedTypeCode } from '../types-v2/bed-type-code';

export const BED_TYPE_META: Record<BedTypeCode, IBedTypeWithMeta> = {
  A: {
    name: 'A',
    bedType: 'A',
    formerly: 'Long Term Care',
    description:
      '24/7 RN/RPN care for complex health needs not manageable at home.',
  },
  B: {
    name: 'B',
    bedType: 'B',
    formerly: 'Designated Supportive Living',
    description: 'Home-like setting with 24/7 LPN and HCA care.',
  },
  BSecure: {
    name: 'B-Secure',
    bedType: 'BSecure',
    formerly: 'Designated Supportive Living 4-D',
    description: 'Type B with added security features for safety.',
  },
  C: {
    name: 'C',
    bedType: 'C',
    formerly: 'Palliative and End-of-Life Care',
    description: '24/7 hospice care for individuals nearing end-of-life.',
  },
};
